import classNames from "classnames";
import { twMerge } from "tailwind-merge";

interface SectionContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  section: any;
}

const SectionContainer = ({ className, section, style, ...props }: SectionContainerProps) => {
  return (
    <div
      className={twMerge(
        classNames("container mx-auto flex flex-col gap-20 px-4 py-28", className, section?.ContainerElement?.ClassName)
      )}
      id={section?.ContainerElement?.HtmlId}
      style={{
        ...style,
        ...section?.ContainerElement?.Style,
      }}
      {...props}
      {...section?.ContainerElement?.Rest}
    />
  );
};

export default SectionContainer;
